var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-work-stats",attrs:{"title":_vm.helpText}},[_vm._v(" "+_vm._s(_vm.workStatsText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }